import { z } from "zod";
import { ElementTypeEnum } from "../../../elementTypeMappings";
import MaterialTypeEnum from "../../../enums/MaterialTypeEnum";
import SceneObjectTypeEnum from "../../../model/sceneObjectData/SceneObjectTypeEnum";
import UserRightScopeEnum from "../../../enums/UserRightScopeEnum";

export const elementTypeEnumSchema = z.enum(
    Object.values(ElementTypeEnum) as [string, ...string[]]
);

export const materialTypeEnumSchema = z.enum(
    Object.values(MaterialTypeEnum) as [string, ...string[]]
);

export const sceneObjectTypeEnumSchema = z.enum(
    Object.values(SceneObjectTypeEnum) as [string, ...string[]]
);

export const userRightScopeEnumSchema = z.enum(
    Object.values(UserRightScopeEnum) as [string, ...string[]]
);